/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import qrcode from 'qrcode';

// Components
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';
import ExpandDetails from '../ExpandDetails.vue';

const __vue_script__ = {
    name: 'PersonActions',

    components: {
        EmailTemplatePicker,
        ExpandDetails,
    },

    props: {
        branding: {
            type: String,
            required: true,
        },

        eid: {
            type: String,
            required: true,
        },

        userDoc: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            actcode: undefined,
            qrcodeSrc: undefined,
            selectedTemplate: undefined
        };
    },

    computed: {
        mobileAppInstallUrl() {
            return `${this.$const.INSTALL_MOBILE_APP_BASE_URL}/${this.branding}`;
        }
    },

    async created() {
        this.actcode = await this.$services.pax.getPaxActCode(this.eid, this.userDoc._id)
            .catch(err =>
                console.error('[PersonActions] Could not get actcode', err.message)
            );
        const url = `${this.mobileAppInstallUrl}?code=${this.actcode}`;
        this.qrcodeSrc = await qrcode.toDataURL(url, { width: 400 })
            .catch(err =>
                console.error('[PersonActions] Could not genereate qr code', err.message)
            );
    },

    methods: {
        sendEmail() {
            const onConfirm = async () => {
                this.$modal.hide('dialog');
                try {
                    await this.$services.emails.sendEmails({
                        eventId: this.eid,
                        templateExtId: this.selectedTemplate,
                        recipientsExtIds: [this.userDoc.fp_ext_id]
                    });
                    this.notify(this.$t('user_display.email_sent'));
                } catch (error) {
                    console.error('[PersonActions] Could send email:', error.message);
                    this.notify(this.$t('user_display.email_not_sent'), 'error');
                }
            };

            this.$modal.show('dialog', {
                text: this.$t('user_display.confirm_send_email'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        handler: () => this.$modal.hide('dialog'),
                        class: 'btn',
                    },
                    {
                        title: this.$t('users.actions.send'),
                        handler: onConfirm,
                        class: 'btn btn-primary',
                    }
                ],
            });
        },

        onCopiedActcodeToClipboard() {
            this.notify(this.$t('general.copy_success'));
        },

        /**
         * @param {string} text
         * @param {string} [type="success"]
         */
        notify(text, type = 'success') {
            this.$notify({
                group: 'flashes',
                text,
                type,
                duration: 3000
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-actions"},[_c('expand-details',{attrs:{"label":_vm.$t('emailing.actions.send_email')}},[_c('email-template-picker',{attrs:{"event-id":_vm.eid,"placeholder":_vm.$t('emailing.actions.send_email_placeholder'),"name":"send_email","open-direction":"below","disabled":_vm.userDoc.unsubscribed_from_emails},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}}),_c('button',{staticClass:"btn important",attrs:{"disabled":!_vm.selectedTemplate || _vm.userDoc.unsubscribed_from_emails,"type":"button"},on:{"click":_vm.sendEmail}},[_vm._v(_vm._s(_vm.$t('users.actions.send')))])],1),_c('expand-details',{attrs:{"label":_vm.$t('user_display.access_the_app')}},[_c('label',[_vm._v(_vm._s(_vm.$t('user_display.event_password')))]),(_vm.actcode)?_c('div',{staticClass:"event-password"},[_c('pre',[_vm._v(_vm._s(_vm.actcode))]),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.actcode),expression:"actcode",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopiedActcodeToClipboard),expression:"onCopiedActcodeToClipboard",arg:"success"}],staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$t('general.copy')))])]):_vm._e(),_c('hr'),_c('label',[_vm._v(_vm._s(_vm.$t('user_display.install_app')))]),_c('div',{staticClass:"install-app boxed-content"},[_c('p',[_vm._v(_vm._s(_vm.$t('user_display.use_mobile_app_url')))]),_c('a',{attrs:{"href":_vm.mobileAppInstallUrl,"title":_vm.$t('user_display.install_app')}},[_vm._v(_vm._s(_vm.mobileAppInstallUrl))]),_c('div',{staticClass:"or"},[_vm._v(_vm._s(_vm.$t('base.or')))]),_c('p',[_vm._v(_vm._s(_vm.$t('user_display.scan_qr_code')))]),(_vm.qrcodeSrc)?_c('img',{attrs:{"src":_vm.qrcodeSrc,"alt":_vm.$t('user_display.scan_qr_code')}}):_vm._e()])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PersonActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__